import React, { Component } from 'react';
import styled from 'styled-components';

const HandBackMessageContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  min-height: 23px;
  margin: 16px;
  padding: 6px 20px;
  box-sizing: border-box;

  border-radius: 5px;
  border: solid 1px #f0f0f0;
  background-color: #ffffff;

  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #4a4a4a;
`;

const OperatorEndedMessageContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;

  padding-top: 20px
  padding-left: 20px;
  padding-right: 20px;

  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  font-weight: normal;
  color: #787871;`;

class TakeoverMessage extends Component {
  render() {
    const botName = this.props.activity.from.name;
    const { operatorName } = this.props.activity;
    return (
      <div>
        <OperatorEndedMessageContainer>
          {operatorName
            ? `Your conversation with ${operatorName} has ended.`
            : 'Your conversation has ended.'}
        </OperatorEndedMessageContainer>
        <HandBackMessageContainer>{botName} is back online!</HandBackMessageContainer>
      </div>
    );
  }
}

export default TakeoverMessage;



// WEBPACK FOOTER //
// ./src/components/MetaMessages/HandBackMessage.js